import {
    FacetType,
    FacetTypeToValueMap
} from "@/components/Search/SearchResults/StateComponents/Facets/Facet/@types/facetType.types";
import { SearchComponentOfType } from "@/utils/search/types/searchComponent";

export type Facet<TFacetType extends FacetType> = {
    name: string;
    order: number;
    type: TFacetType;
    values: FacetTypeToValueMap[TFacetType];
    index: string;
};

export const isFacetType = <TFacetType extends FacetType>(
    facetType: TFacetType,
    facet: Facet<FacetType>
): facet is Facet<TFacetType> => facet.type === facetType;

export type FacetComponentProps<TFacetType extends FacetType> = {
    facet: Facet<TFacetType>;
    component: SearchComponentOfType<"FACETS">;
    sendEvent: (faceName: string, facetValue: string) => void;
};
